<template>
  <div
    class="radio"
    :class="{ 'radio-checked': checked }"
    @click.stop="bindClick"
  >
    <span class="radio-num">{{ sort | upperChar }}.</span
    ><span><slot></slot></span>
    <div class="iconfont icon-gou" v-show="checked && type == 1"></div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: Number,
      default: 0 //默认单选 1表示多选
    },
    disabled: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    active: {
      default: ''
    },
    sort: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: false
    }
  },
  filters: {
    upperChar(str) {
      return str.toUpperCase()
    }
  },
  watch: {
    active() {
      this.updateCheck()
    }
  },
  created() {
    this.updateCheck()
  },
  methods: {
    updateCheck() {
      if (this.type == 0) {
        this.checked = this.index == this.active
      } else {
        this.checked = this.active.includes(this.index)
      }
    },
    bindClick() {
      if (this.disabled) {
        return
      }
      if (this.type !== 0) {
        this.checked = !this.checked
      }
      this.$emit('change', this.index, this.checked)
    }
  }
}
</script>
<style lang="scss" scoped>
.radio {
  text-align: center;
  position: relative;
  padding: 6px 20px;
  box-sizing: border-box;
  white-space: nowrap;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.07);
  border-radius: 100px;
  border: 3px solid transparent;
  font-size: 15px;
  font-family: GothamBold;
  color: rgba(0, 0, 0, 0.8);
  line-height: 24px;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.07);
  .radio-num {
    font-weight: 600;
    margin-right: 4px;
  }
  .iconfont {
    position: absolute;
    right: 0%;
    top: 50%;
    transform: translate(50%, -50%);
    border-radius: 50%;
    overflow: hidden;
    width: 20px;
    height: 20px;
    background: #0e0e0e;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }
}
.radio-checked {
  border: 3px solid #000000;
  font-weight: 600;
}
</style>
